import React from 'react';

import FieldList_TableGroup from '../../../components/plain/FieldList_TableGroup';

class TabAACommunications extends React.Component {
	
	constructor(props) {
		super(props);
	}

	render() {
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<div style={{padding: '10px' }}>
				<FieldList_TableGroup instance={instance} path={'communication'} parentField={parentField}
					plain={plain} plainDirtyCounter={plain.state.plainDirtyCounter} ignoreTitle={true}
					readOnly={readOnly} 
					table={{
						columns: [
							{ columnId: 'type', styles: {tdHeader: {width: '20%'}} }, 
							{ columnId: 'value', styles: {tdHeader: {width: '40%'}} },
							{ columnId: 'notes', styles: {tdHeader: {width: '40%'}} },
						],
					}}
					styles={{
						table: {width: '100%'},
						trHeader: {height: '43px'}
					}}
				/>
			</div>
		);
	}
}

export default TabAACommunications;
